import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { basePublicRoutes } from 'src/app/submodules/angular-ui-common/public-routes';
import { RoutingGuardService } from '../../submodules/angular-common/routing-guard.service';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { HomeComponent } from './components/home/home.component';
import { PublicAreaComponent } from './components/public-area.component';

export const publicAreaRoutes: Routes = [
    {
        path: '', component: PublicAreaComponent, children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            ...basePublicRoutes,
            { path: 'home', component: HomeComponent, canActivate: [RoutingGuardService] },
            { path: 'contacts', component: ContactsComponent, canActivate: [RoutingGuardService] },
            // { path: 'how-to-intervene', component: HowToInterveneComponent, canActivate: [RoutingGuardService] },
            { path: 'cookie-policy', component: CookiePolicyComponent, canActivate: [RoutingGuardService] }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(publicAreaRoutes)],
    exports: [RouterModule]
})

export class PublicAreaRoutingModule {
    constructor() {
        console.log('PublicAreaRoutingModule loaded.');
    }
}